import { render, staticRenderFns } from "./TerminalRequestLinux.vue?vue&type=template&id=1513b1ca"
import script from "./TerminalRequestLinux.vue?vue&type=script&lang=js"
export * from "./TerminalRequestLinux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports